module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "calendrier",
    staticClass: "section-calendrier noselect h-100 w-100 position-relative d-flex flex-column",
    attrs: {
      "data-testid": "absencePlanning-section"
    }
  }, [(_vm.enableAction) ? _c('div', {
    staticClass: "tooltip-conge",
    class: {
      'd-block': _vm.tooltipVisible
    },
    style: ({
      left: _vm.tooltipPosition.x + 'px',
      top: _vm.tooltipPosition.y + 'px'
    })
  }, [_c('ul', {
    staticClass: "list-action"
  }, [(_vm.estPossibleValiderAbsence()) ? _c('li', {
    staticClass: "action action-valid",
    on: {
      "click": function($event) {
        _vm.tooltipValid()
      }
    }
  }, [_c('span', {
    staticClass: "icon fas fa-check fa-fw mr-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Valider")])]) : _vm._e(), _vm._v(" "), (_vm.estPossibleValiderDemandeAnnulation()) ? _c('li', {
    staticClass: "action action-valid",
    attrs: {
      "data-testid": "absencePlanning-table-acceptCancelation-button"
    },
    on: {
      "click": function($event) {
        _vm.tooltipValiderDemandeAnnulation()
      }
    }
  }, [_c('span', {
    staticClass: "icon fas fa-check fa-fw mr-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Valider la demande d'annulation")])]) : _vm._e(), _vm._v(" "), (_vm.estPossibleModifierAbsence()) ? _c('li', {
    staticClass: "action action-modify",
    attrs: {
      "data-testid": "absencePlanning-table-editAbsence-button"
    },
    on: {
      "click": function($event) {
        _vm.tooltipContinue(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon fas fa-pencil-alt fa-fw mr-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Modifier")])]) : _vm._e(), _vm._v(" "), (_vm.estPossibleSupprimerAbsence()) ? _c('li', {
    staticClass: "action action-delete",
    attrs: {
      "data-testid": "absencePlanning-table-cancelAbsence-button"
    },
    on: {
      "click": function($event) {
        _vm.tooltipContinue(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon fas fa-trash-alt fa-fw mr-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Annuler")])]) : _vm._e(), _vm._v(" "), (_vm.estPossibleAnnulerDemandeAnnulation()) ? _c('li', {
    staticClass: "action action-delete",
    attrs: {
      "data-testid": "absencePlanning-table-cancelCancelation-button"
    },
    on: {
      "click": function($event) {
        _vm.tooltipAnnulerDemandeAnnulation()
      }
    }
  }, [_c('span', {
    staticClass: "icon fas fa-trash-alt fa-fw mr-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Annuler la demande d'annulation")])]) : _vm._e(), _vm._v(" "), (_vm.estPossibleGenererAttestationCrpcen()) ? _c('li', {
    staticClass: "action action-generate",
    attrs: {
      "data-testid": "absencePlanning-table-generateCertificate-button"
    },
    on: {
      "click": function($event) {
        _vm.generationCRPCEN()
      }
    }
  }, [_c('span', {
    staticClass: "icon fas fa-cloud-download-alt fa-fw mr-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("CRPCEN")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "head d-flex mb-2 flex-wrap"
  }, [_c('div', {
    staticClass: "head-left"
  }, [_c('div', {
    staticClass: "title-head",
    attrs: {
      "data-testid": "absencePlanning-section-title"
    }
  }, [_vm._v("Planning des absences")]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "area area-filter"
  }, [_c('div', {
    staticClass: "separator ml-2 mr-2"
  }), _vm._v(" "), (_vm.enableFilter && !_vm.getData.EstAffichagePlanningAnonymise) ? _c('input-select', {
    attrs: {
      "code": "Code",
      "data-testid": "absencePlanning-absenceType-filter",
      "display": "Libelle",
      "height": "150",
      "label": 'Filtrer les absences',
      "list": _vm.listLegendTemp,
      "first": true,
      "disabled": _vm.dataChange || !_vm.listLegendTemp.length,
      "vmodel": _vm.filterTypeConges
    },
    on: {
      "update:vmodel": function($event) {
        _vm.filterTypeConges = $event
      },
      "change": function($event) {
        _vm.filterData()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input-select', {
    staticClass: "ml-2",
    attrs: {
      "data-testid": "absencePlanning-regroupEmployee-filter",
      "code": "key",
      "display": "value",
      "height": "150",
      "label": 'Regrouper les salariés',
      "list": _vm.listSortDisplay,
      "disabled": _vm.dataChange,
      "vmodel": _vm.sortDisplaySelected
    },
    on: {
      "update:vmodel": function($event) {
        _vm.sortDisplaySelected = $event
      },
      "change": function($event) {
        _vm.firstSetGroup = true;
        _vm.filterData();
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataReady && _vm.enableExport) ? _c('div', {
    staticClass: "area area-export"
  }, [_c('div', {
    staticClass: "separator ml-2 mr-2"
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": _vm.dataChange || !_vm.haveConge,
      "data-testid": "absencePlanning-export-button",
      "icon": "fas fa-file-export",
      "color": "blue",
      "text": "Exporter",
      "title": "Exporter le planning des absences"
    },
    on: {
      "click": function($event) {
        _vm.exporter()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataReady && _vm.enableCollective) ? _c('div', {
    staticClass: "area area-collective"
  }, [_c('div', {
    staticClass: "separator ml-2 mr-2"
  }), _vm._v(" "), _c('Button', {
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.dataChange,
      "data-testid": "absencePlanning-addCollectiveAbsence-button",
      "icon": "fas fa-plus",
      "color": "green",
      "title": "Ajouter une absence collective",
      "text": "Ajouter une AC"
    },
    on: {
      "click": function($event) {
        _vm.addAbsenceCollective()
      }
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": _vm.dataChange,
      "data-testid": "absencePlanning-deleteCollectiveAbsence-button",
      "icon": "fas fa-trash-alt",
      "color": "red",
      "text": "Supprimer une AC",
      "title": "Supprimer une absence collective"
    },
    on: {
      "click": function($event) {
        _vm.deleteAbsenceCollective()
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "head-right"
  }, [(_vm.dataReady && _vm.enableSearch) ? _c('div', {
    staticClass: "area area-search"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterName),
      expression: "filterName"
    }],
    staticClass: "input input-search",
    attrs: {
      "type": "text",
      "data-testid": "absencePlanning-search-input",
      "maxlength": "50",
      "placeholder": " ",
      "disabled": _vm.dataChange
    },
    domProps: {
      "value": (_vm.filterName)
    },
    on: {
      "keyup": function($event) {
        _vm.filterData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Rechercher un salarié")]), _vm._v(" "), (!_vm.filterName.length) ? _c('span', {
    staticClass: "icon-inner fas fa-search"
  }) : _c('span', {
    staticClass: "icon-inner fas fa-times cls",
    on: {
      "click": function($event) {
        _vm.filterName = '';
        _vm.filterData()
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "area-calendrier"
  }, [_c('div', {
    staticClass: "inp-calendrier",
    class: _vm.dataReady && _vm.enableLegend && _vm.listLegendTemp.length && !_vm.getData.EstAffichagePlanningAnonymise ? 'space-legend' : ''
  }, [_c('div', {
    staticClass: "calendar-head"
  }, [_c('div', {
    staticClass: "head-left tw-relative",
    class: {
      'border-ready': _vm.dataReady
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('button', {
    staticClass: "button-calendrier btn-left",
    attrs: {
      "type": "button",
      "data-testid": "absencePlanning-table-prevMonth",
      "title": "Mois précédent",
      "disabled": !_vm.dataReady
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.naviguateMonth(false)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-angle-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tw-relative"
  }, [_c('div', {
    staticClass: "center",
    class: _vm.dataReady ? 'visible' : 'tw-pointer-events-none',
    attrs: {
      "data-testid": "absencePlanning-table-date",
      "data-cy": "cy-calendar-date"
    },
    on: {
      "click": _vm.showDateSelector
    }
  }, [_c('span', {
    staticClass: "month",
    attrs: {
      "data-testid": "absencePlanning-table-month"
    }
  }, [_vm._v(_vm._s(_vm.monthNames[_vm.currentMonth]))]), _vm._v(" "), _c('span', {
    staticClass: "year",
    attrs: {
      "data-testid": "absencePlanning-table-year"
    }
  }, [_vm._v(_vm._s(_vm.currentYear))]), _vm._v(" "), _c('span', {
    staticClass: "tw-text-sm tw-ml-[10px] icon-inner fas fa-angle-down tw-transition-all",
    class: _vm.isDatePickerVisible ? 'tw-rotate-180' : 'tw-rotate-0'
  })]), _vm._v(" "), (_vm.isDatePickerVisible) ? _c('date-picker-modal', {
    attrs: {
      "currentYear": _vm.currentYear
    },
    on: {
      "selectedDate": _vm.selectedDate,
      "closeModal": function($event) {
        _vm.isDatePickerVisible = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "button-calendrier btn-right",
    attrs: {
      "type": "button",
      "data-testid": "absencePlanning-table-nextMonth",
      "title": "Mois suivant",
      "disabled": !_vm.dataReady
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.naviguateMonth(true)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "head-right",
    class: {
      'data-change': _vm.dataChange
    }
  }, [_c('Scroll', {
    attrs: {
      "scrollHide": "true",
      "spaceRight": "true",
      "disableAction": "true",
      "valueSyncHorizontal": _vm.valueSyncHorizontal
    }
  }, _vm._l((_vm.listDays), function(day) {
    return _c('div', {
      staticClass: "date",
      class: day.ferie !== undefined ? 'is-ferie' : (day.day.nameDay === 0 || day.day.nameDay === 6) ? 'w-e' : '',
      attrs: {
        "title": (day.ferie !== undefined) ? day.ferie.Libelle : ''
      }
    }, [_c('div', {
      staticClass: "day",
      class: day.ferie !== undefined ? 'is-ferie' : ''
    }, [_vm._v("\n                                    " + _vm._s(_vm.dayNames[day.day.nameDay]) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "number tw-flex tw-justify-center",
      class: day.ferie !== undefined ? 'is-ferie' : ''
    }, [_c('div', {
      class: [{
        'tw-bg-sky-600 tw-rounded tw-text-white tw-w-1/2 tw-relative': day.isToday
      }]
    }, [_vm._v("\n                                        " + _vm._s(day.day.valueDay) + "\n                                    ")])]), _vm._v(" "), (day.ferie !== undefined) ? _c('div', {
      staticClass: "date-txt is-ferie"
    }, [_vm._v("\n                                    Férié\n                                ")]) : _vm._e()])
  }))], 1) : _c('div', {
    staticClass: "loading loading-top w-100 h-100"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calendar-body"
  }, [_c('div', {
    staticClass: "body-left",
    class: {
      'd-none': !_vm.dataReady || _vm.problemeChargement, 'data-change': _vm.dataChange
    }
  }, [_c('Scroll', {
    ref: "scrollLeftCalendar",
    attrs: {
      "scrollHide": "true",
      "spaceBottom": "true",
      "valueSyncVertical": _vm.valueSyncVertical,
      "syncVertical": _vm.valueSyncVertical,
      "displayColumn": "true"
    },
    on: {
      "update:syncVertical": function($event) {
        _vm.valueSyncVertical = $event
      }
    }
  }, _vm._l((_vm.listTypeAbsence), function(typeAbsence) {
    return _c('div', {
      staticClass: "area"
    }, [_c('div', {
      staticClass: "head",
      class: {
        'hover': typeAbsence.IsHover,
          'd-none': _vm.hideDisplayHead()
      },
      attrs: {
        "data-testid": "absencePlanning-table-head",
        "title": typeAbsence.Type
      },
      on: {
        "click": function($event) {
          _vm.switchExpand(typeAbsence)
        },
        "mouseover": function($event) {
          _vm.hoverHeader(typeAbsence)
        },
        "mouseleave": function($event) {
          _vm.leaveHeader(typeAbsence)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(typeAbsence.Type) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "body",
      class: {
        'expand': typeAbsence.IsCollapse
      }
    }, _vm._l((typeAbsence.Salariees), function(salariee) {
      return _c('div', {
        staticClass: "box"
      }, [_c('span', {
        staticClass: "user",
        class: {
          'no-hover': !_vm.enableNavigation
        },
        attrs: {
          "title": salariee.FullName
        },
        on: {
          "click": function($event) {
            _vm.openSalarie(salariee.Id, salariee.Intitule)
          }
        }
      }, [_c('span', {
        staticClass: "name",
        attrs: {
          "data-testid": "absencePlanning-table-salarie-name"
        }
      }, [_vm._v(_vm._s(salariee.FullName))])]), _vm._v(" "), (_vm.enableAction) ? _c('span', {
        staticClass: "more",
        attrs: {
          "title": "Ajouter une absence",
          "data-testid": _vm.getAddAbsenceButtonDataTestID(salariee.FullName)
        },
        on: {
          "click": function($event) {
            _vm.addAbsence(salariee.Id)
          }
        }
      }, [_c('span', {
        staticClass: "fas fa-plus"
      })]) : _vm._e()])
    }))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "loading loading-left h-100",
    class: {
      'd-none': _vm.dataReady
    }
  }, [_c('Loader')], 1), _vm._v(" "), _c('div', {
    staticClass: "body-right",
    class: {
      'd-none': !_vm.dataReady || _vm.problemeChargement, 'data-change': _vm.dataChange
    }
  }, [_c('Scroll', {
    ref: "scrollRightCalendar",
    attrs: {
      "displayColumn": "true",
      "valueSyncHorizontal": _vm.valueSyncHorizontal,
      "syncHorizontal": _vm.valueSyncHorizontal,
      "valueSyncVertical": _vm.valueSyncVertical,
      "syncVertical": _vm.valueSyncVertical,
      "valueSyncIsSmooth": _vm.valueSyncIsSmooth
    },
    on: {
      "update:syncHorizontal": function($event) {
        _vm.valueSyncHorizontal = $event
      },
      "update:syncVertical": function($event) {
        _vm.valueSyncVertical = $event
      },
      "update:valueSyncIsSmooth": function($event) {
        _vm.valueSyncIsSmooth = $event
      }
    }
  }, _vm._l((_vm.listTypeAbsence), function(typeAbsence) {
    return _c('div', {
      staticClass: "area"
    }, [_c('div', {
      staticClass: "head",
      class: {
        'hover': typeAbsence.IsHover, 'd-none': _vm.hideDisplayHead()
      },
      on: {
        "mouseover": function($event) {
          _vm.hoverHeader(typeAbsence)
        },
        "mouseleave": function($event) {
          _vm.leaveHeader(typeAbsence)
        },
        "click": function($event) {
          _vm.switchExpand(typeAbsence)
        }
      }
    }, [_c('div', {
      staticClass: "right mr-2"
    }, [_c('span', {
      staticClass: "fas fa-fw fa-xs fa-chevron-down",
      class: {
        'fa-rotate-180': !typeAbsence.IsCollapse
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "body",
      class: {
        'expand': typeAbsence.IsCollapse, 'have-head': _vm.sortDisplaySelected !== _vm.getEnumAlphabetique()
      }
    }, _vm._l((typeAbsence.Salariees), function(salariee) {
      return _c('div', {
        staticClass: "timeline"
      }, _vm._l((salariee.JoursDuMois), function(day) {
        return _c('div', {
          staticClass: "box",
          class: _vm.getClassWeekEndEtFerie(day.Date)
        }, [(day.Conges.length) ? _c('div', {
          staticClass: "cell",
          class: _vm.getClassCell(day)
        }, [_c('div', {
          staticClass: "wrap"
        }, [_c('div', {
          staticClass: "demi demi-left",
          class: _vm.getClassDemi(day.Conges, 'M'),
          style: ('backgroundColor: ' + _vm.getColorCell(salariee, day.Conges, 'M')),
          attrs: {
            "data-testid": _vm.getAbsenceDataTestID(salariee, day, 'M'),
            "title": _vm.getTitle(salariee, day.Conges, 'M')
          },
          on: {
            "mouseover": function($event) {
              _vm.hoverCell(day.Conges, 'M')
            },
            "mouseleave": function($event) {
              _vm.leaveCell()
            },
            "click": function($event) {
              _vm.openTooltip(salariee, day.Conges, 'M', $event)
            }
          }
        }, [_c('div', {
          staticClass: "inner",
          style: (_vm.getColorInner(salariee, day.Conges, 'M'))
        }), _vm._v(" "), (_vm.isCongeEnAnnulation(day.Conges, 'M')) ? _c('span', {
          staticClass: "icon-annuler icon fa-duotone fa-circle-minus",
          style: ('--fa-secondary-color:' + _vm.getColorCell(salariee, day.Conges, 'M'))
        }) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "demi demi-right",
          class: _vm.getClassDemi(day.Conges, 'A'),
          style: ('backgroundColor: ' + _vm.getColorCell(salariee, day.Conges, 'A')),
          attrs: {
            "data-testid": _vm.getAbsenceDataTestID(salariee, day, 'A'),
            "title": _vm.getTitle(salariee, day.Conges, 'A')
          },
          on: {
            "mouseover": function($event) {
              _vm.hoverCell(day.Conges, 'A')
            },
            "mouseleave": function($event) {
              _vm.leaveCell()
            },
            "click": function($event) {
              _vm.openTooltip(salariee, day.Conges, 'A', $event)
            }
          }
        }, [_c('div', {
          staticClass: "inner",
          style: (_vm.getColorInner(salariee, day.Conges, 'A'))
        }), _vm._v(" "), (_vm.isCongeEnAnnulation(day.Conges, 'A') && _vm.shouldShowAnnulationOnCellRight(day.Conges, 'A')) ? _c('span', {
          staticClass: "icon-annuler icon fa-duotone fa-circle-minus",
          style: ('--fa-secondary-color:' + _vm.getColorCell(salariee, day.Conges, 'A'))
        }) : _vm._e()])])]) : _vm._e()])
      }))
    }))])
  })), _vm._v(" "), _c('Scroll', {
    staticClass: "wrap-sub-body",
    attrs: {
      "valueSyncHorizontal": _vm.valueSyncHorizontal,
      "spaceBottom": "true",
      "spaceRight": "true",
      "scrollHide": "true"
    }
  }, [_c('div', {
    staticClass: "sub-body",
    attrs: {
      "id": "scrollSub"
    }
  }, _vm._l((_vm.listDays), function(day) {
    return _c('div', {
      staticClass: "date",
      class: day.ferie !== undefined ? 'is-ferie' : (day.day.nameDay === 0 || day.day.nameDay === 6) ? 'w-e' : ''
    })
  }))]), _vm._v(" "), (_vm.enableAction) ? _c('div', {
    staticClass: "overlay-tooltip",
    class: _vm.tooltipVisible ? '' : 'hide',
    on: {
      "click": function($event) {
        _vm.closeTooltip()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "loading loading-right flex-grow-1 h-100",
    class: !_vm.problemeChargement && !_vm.dataReady ? 'd-block' : 'd-none'
  }, [_c('Loader')], 1), _vm._v(" "), _c('div', {
    staticClass: "probleme-chargement flex-grow-1 h-100",
    class: _vm.problemeChargement ? 'd-flex' : 'd-none'
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("Une erreur est survenue lors du chargement du calendrier.")])])]), _vm._v(" "), (_vm.dataReady && _vm.enableLegend && _vm.listLegendTemp.length && !_vm.getData.EstAffichagePlanningAnonymise) ? _c('div', {
    staticClass: "labels d-flex mt-3"
  }, _vm._l((_vm.listLegendTemp), function(type) {
    return _c('div', {
      staticClass: "label mr-3",
      attrs: {
        "title": type.Libelle
      }
    }, [_c('span', {
      staticClass: "puce mr-2",
      style: (_vm.getStyleLegendColor(type.Couleur))
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(type.Code))])])
  })) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-warning mb-2"
  }, [_c('span', {
    staticClass: "fas fa-exclamation-triangle fa-3x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bef8738"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendrier/calendrier.vue.html
// module id = mnes
// module chunks = 2